import ComprobantDetailPaymentBody from "./components/ComprobantDetailPaymentBody/ComprobantDetailPaymentBody"
import ComprobantDetailPaymentHeader from "./components/ComprobantDetailPaymentHeader/ComprobantDetailPaymentHeader"


const ComprobantDetailPaymentPage = () => {
    return (
        <section className="section-wrapper">
            <ComprobantDetailPaymentHeader />
            <ComprobantDetailPaymentBody />
        </section>
    )
}

export default ComprobantDetailPaymentPage
